import React, {useState} from "react";
import {Button, Modal, Typography, Grid, InputLabel, Card, CardContent, TextField} from "@material-ui/core";
import axios from "../../api";

function VisualizarPacientes({id, title, apiUrl}) {
    const [open, setOpen] = useState(false);
    const [data, setData] = useState(null);

    const handleOpen = () => {
        setOpen(true);
        const token = localStorage.getItem('token');
        axios.get(apiUrl + id, {headers: {Authorization: `Bearer ${token}`}})
            .then((response) => {
                console.log(response.data.data)
                setData(response.data.data);
            });
    };


    const handleClose = () => {
        setOpen(false);
    };

    return (
        <div>
            <Button variant="contained" color="primary" size="small" onClick={handleOpen}>
                <i className="fas fa-eye"></i> Visualizar
            </Button>
            <Modal open={open} onClose={handleClose}>
                <div
                    style={{
                        position: "absolute",
                        top: "40%",
                        left: "54%",
                        transform: "translate(-50%, -50%)",
                        width: "70%",
                        backgroundColor: "white",
                        borderRadius: '20px',
                    }}
                >
                    <Card>
                        <CardContent>
                            <Typography variant="h5">{title}</Typography>
                            <br/>
                            {data && (
                                <Grid item xs={12}>
                                    <Grid container spacing={3}>
                                        <Grid item xs={4}>
                                            <InputLabel style={{padding: '0.5rem'}}>Nome do paciente</InputLabel>
                                            <TextField
                                                fullWidth
                                                size="small"
                                                id="outlined-required"
                                                placeholder={"Nome do paciente"}
                                                variant="outlined"
                                                value={data.name}
                                                disabled={true}
                                            />
                                        </Grid>

                                        <Grid item xs={4}>
                                            <InputLabel style={{padding: '0.5rem'}}>E-mail do paciente</InputLabel>
                                            <TextField
                                                fullWidth
                                                size="small"
                                                id="outlined-required"
                                                placeholder={"Nome do paciente"}
                                                variant="outlined"
                                                value={data.email}
                                                disabled={true}
                                            />
                                        </Grid>
                                        <Grid item xs={4}>
                                            <InputLabel style={{padding: '0.5rem'}}>CPF</InputLabel>
                                            <TextField
                                                fullWidth
                                                size="small"
                                                id="outlined-required"
                                                placeholder={"CPF"}
                                                variant="outlined"
                                                value={data.cpf}
                                                disabled={true}
                                            />
                                        </Grid>
                                        <Grid item xs={4}>
                                            <InputLabel style={{padding: '0.5rem'}}>RG</InputLabel>
                                            <TextField
                                                fullWidth
                                                size="small"
                                                id="outlined-required"
                                                placeholder={"RG"}
                                                variant="outlined"
                                                value={data.rg}
                                                disabled={true}
                                            />
                                        </Grid>
                                        <Grid item xs={4}>
                                            <InputLabel style={{padding: '0.5rem'}}>Sexo</InputLabel>
                                            <TextField
                                                fullWidth
                                                size="small"
                                                id="outlined-required"
                                                placeholder={"RG"}
                                                variant="outlined"
                                                value={data.genero}
                                                disabled={true}
                                            />
                                        </Grid>


                                        <Grid item xs={4}>
                                            <InputLabel style={{padding: '0.5rem'}}>Data nascimento</InputLabel>
                                            <TextField
                                                fullWidth
                                                size="small"
                                                id="outlined-required"
                                                placeholder={"RG"}
                                                variant="outlined"
                                                value={data.data_nascimento}
                                                disabled={true}
                                            />
                                        </Grid>

                                        <Grid item xs={4}>
                                            <InputLabel style={{padding: '0.5rem'}}>CNS</InputLabel>
                                            <TextField
                                                fullWidth
                                                size="small"
                                                id="outlined-required"
                                                placeholder={"CNS"}
                                                variant="outlined"
                                                value={data.cns}
                                                disabled={true}
                                            />
                                        </Grid>

                                        <Grid item xs={4}>
                                            <InputLabel style={{padding: '0.5rem'}}>Tipo de Atendimento</InputLabel>
                                            <TextField
                                                fullWidth
                                                size="small"
                                                id="outlined-required"
                                                placeholder={"RG"}
                                                variant="outlined"
                                                value={data.preferencial}
                                                disabled={true}
                                            />
                                        </Grid>

                                        <Grid item xs={4}>
                                            <InputLabel style={{padding: '0.5rem'}}>Data Cadastro</InputLabel>
                                            <TextField
                                                fullWidth
                                                size="small"
                                                id="outlined-required"
                                                placeholder={"RG"}
                                                variant="outlined"
                                                value={data.created_at}
                                                disabled={true}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>

                            )}
                        </CardContent>
                    </Card>
                </div>
            </Modal>
        </div>
);
}

export default VisualizarPacientes;
